export var constants = {
	isLite: false, // toggling daarc lite
	doSomethingTimeout: 2000,
	uiTags: {
		Hud: 'Hud'
	},
	toolbagTools: {
		bvm: {
			img: './assets/images/Toolbag/bvm_new.png',
			text: 'BVM'
		},
		ett: {
			img: './assets/images/Toolbag/ett_new.png',
			text: 'ETT'
		},
		sga: {
			img: './assets/images/Toolbag/sga_new.png',
			text: 'SGA'
		},
		cric: {
			img: './assets/images/Toolbag/cric_new.png',
			text: 'Cric'
		}
	},
	cricTools: {
		scalpel: {
			img: './assets/images/Toolbag/scalpel.png',
			text: 'Scalpel'
		},
		bougie: {
			img: './assets/images/Toolbag/bougie.png',
			text: 'Bougie'
		},
		ett: {
			img: './assets/images/Toolbag/ett_cric.png',
			text: 'ETT'
		},
		spreader: {
			img: './assets/images/Toolbag/spreader.png',
			text: 'Spreader'
		},
		syringe: {
			img: './assets/images/Toolbag/syringe.png',
			text: 'Syringe'
		}
	},
	uiNames: {
		HUDUI: 'HUDUI',
		VortexUI: 'VortexUI',
		ToolbagUI: 'ToolbagUI',
		DraggedToolsUI: 'DraggedToolsUI',
		PalpateNeckUI: 'PalpateNeckUI',
		InsertionAngleUI: 'InsertionAngleUI',
		ETTOptionsUI: 'ETTOptionsUI',
		ETTResistanceUI: 'ETTResistanceUI',
		SuccessFailedAttemptUI: 'SuccessFailedAttemptUI',
		EttSpecialUI: 'EttSpecialUI',
		ETTInstrumentInsertionUI: 'ETTInstrumentInsertionUI',
		PreOxygenateOptionsUI: 'PreOxygenateOptionsUI',
		FloatingMessagesUI: 'FloatingMessagesUI',
		VortexJobAidUI: 'VortexJobAidUI',
		GeneralAlertUI: 'GeneralAlertUI',
		SBARUI: 'SBARUI',
		AssessAirwayUI: 'AssessAirwayUI',
		DialogUI: 'DialogUI',
		NotificationUI: 'NotificationUI',
		ScalpelUI: 'ScalpelUI',
		BVMMakeAttemptUI: 'BVMMakeAttemptUI',
		CricMakeAttemptUI: 'CricMakeAttemptUI',
		SideMenuUI: 'SideMenuUI',
		DebriefUI: 'DebriefUI',
		ETTMakeAttemptUI: 'ETTMakeAttemptUI',
		BVMAttemptUI: 'BVMAttemptUI',
		ArtifitialProgressUI: 'ArtifitialProgressUI',
		ETTSizeUI: 'ETTSizeUI',
		SGAMakeAttemptUI: 'SGAMakeAttemptUI',
		AuscultateUI: 'AuscultateUI',
		OptionsUI: 'OptionsUI',
		BVMOptimizationsUI: 'BVMOptimizationsUI',
		ETTOptimizationsUI: 'ETTOptimizationsUI',
		SGAOptimizationsUI: 'SGAOptimizationsUI',
		AdminsterMedsUI: 'AdminsterUI'
	},
	speakers: {
		RnMiranda: '(RN) Miranda',
		DrCaleb: '(Dr) Caleb',
		NathanielClarke: 'Nathaniel Clarke',
		DamonJones: 'Damon Jones',
		JavierMcBride: 'Javier McBride',
		AndreGarza: 'Andre Garza',
		GuadalupeHerrera: 'Guadalupe Herrera',
		DarnellKennedy: 'Darnell Kennedy',
		FaithAlvarado: 'Faith Alvarado',
		EmanuelMcKenzie: 'Emanuel McKenzie',
		RuthMcKenzie: 'Ruth McKenzie',
		Leroyrobinson: 'Leroy Robinson',
		WilliamHoward: 'William Howard',
		AngelaScott: 'Angela Scott',
		Yamal: 'Yamal',
	},
	attemptText: {
		successTitle: 'Congrats on the scenario!',
		tempsuccessTitle: 'Temp Success',
		failedTitle: 'Failed Scenario',
		apneaClockMessage: 'You ran out of time',
		bvm: {
			successMessage: 'This is successful',
			failedMessage: 'This is failed',
		},
		auscultate: {
		},
		ett: {
			successMessage: 'This is successful',
			failedMessage: 'This is failed',
		},
		sga: {
			successMessage: 'This is successful',
			failedMessage: 'This is failed',
		},
		cric: {
			successMessage: 'This is successful',
			failedMessage: 'This is failed',
		}
	},
	monitor: {
		debug: false,
		maxHeartRateIteration: 10,
		minHeartRateIteration: 75,
		hrDataLength: 6000,
		defaultPitch: 300, //values of +100 and -100 detune the source up or down by one semitone, while +1200 and -1200 detune it up or down by one octave. 
		heartRateData: {
			showGrid: false,
			defaultCoordinates: [0,0,2,4,4,2,0,0,-4,-8,0,20,40,20,0,-20,0,0,2,4,6,8,8,6,4,2,0,0,0,0], //4=.3, 6=.25, 8=.16
			defaultCurveResetTimer: 100, //[0,0,0,0,0,0,0,0,0,0,0,0,0,2,4,6,8,12,14,18,24,30,30,32,32,32,30,30,28,24]
			timeInterval: 8, //5=4s, 8=6s, 10=8s
			lineColor: 'rgb(0, 255, 0)',
			centerHeight: false,
			isHeartRate: true
		},
		heartRateDataControls: [
			{
				max: 1,
				min: 0,
				blipTime: 0,
				graphData: {
					coordinates: [0, 0],
				}
			},
			{
				max: 200,
				min: 195,
				blipTime: 95, //[60 / (This bpm (eg 200))] - 205 gives ~time between beeps
				graphData: { //0 starts at time shown line 146
					curveResetTimer: 25 //each single digit increase = ~0.002
				}
			},
			{
				max: 195,
				min: 185,
				blipTime: 111,
				graphData: {
					curveResetTimer: 33 //some viariables are rounded to nearest whole number
				}
			},
			{
				max: 185,
				min: 175,
				blipTime: 128,
				graphData: {
					curveResetTimer: 42
				}
			},
			{
				max: 175,
				min: 165,
				blipTime: 148,
				graphData: {
					curveResetTimer: 51
				}
			},
			{
				max: 165,
				min: 155,
				blipTime: 170,
				graphData: {
					curveResetTimer: 63
				}
			},
			{
				max: 155,
				min: 145,
				blipTime: 195,
				graphData: {
					curveResetTimer: 75
				}
			},
			{
				max: 145,
				min: 135,
				blipTime: 224,
				graphData: {
					curveResetTimer: 89
				}
			},
			{
				max: 135,
				min: 125,
				blipTime: 257,
				graphData: {
					curveResetTimer: 106
				}
			},
			{
				max: 125,
				min: 115,
				blipTime: 295,
				graphData: {
					curveResetTimer: 125
				}
			},
			{
				max: 115,
				min: 105,
				blipTime: 340,
				graphData: {
					curveResetTimer: 148
				}
			},
			{
				max: 105,
				min: 95,
				blipTime: 395,
				graphData: {
					curveResetTimer: 175
				}
			},
			{
				max: 95,
				min: 85,
				blipTime: 462,
				graphData: {
					curveResetTimer: 208
				}
			},
			{
				max: 85,
				min: 75,
				blipTime: 545,
				graphData: {
					curveResetTimer: 250
				}
			},
			{
				max: 75,
				min: 65,
				blipTime: 652,
				graphData: {
					curveResetTimer: 304
				}
			},
			{
				max: 65,
				min: 55,
				blipTime: 795,
				graphData: {
					curveResetTimer: 375
				}
			},
			{
				max: 55,
				min: 45,
				blipTime: 995,
				graphData: {
					curveResetTimer: 475
				}
			},
			{
				max: 45,
				min: 35,
				blipTime: 1295,
				graphData: {
					curveResetTimer: 625
				}
			},
			{
				max: 35,
				min: 25,
				blipTime: 1795,
				graphData: {
					curveResetTimer: 875
				}
			},
			{
				max: 25,
				min: 15,
				blipTime: 2795,
				graphData: {
					curveResetTimer: 1375
				}
			},
			{
				max: 15,
				min: 1,
				blipTime: 5595,
				graphData: {
					curveResetTimer: 2875
				}
			},
		],

		respirationData: {
			showGrid: false,
			defaultCoordinates: [0,0,0,0,0,0,0,0,0,0,0,0,0,0,5.22,10.08,14.58,18.72,22.5,25.92,28.98,31.68,34.02,36,37.62,38.88,39.78,40.32,40.5,40.32],//[0,0,4,8,12,16,20,24,28,28,28,28,28,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
			defaultCurveResetTimer: 10,
			timeInterval: 8,
			smoothlyZeroOut: true,
			lineColor: 'cyan',
			centerHeight: false
		},
		pitch: [
			{
				max: 100,
				min: 95,
				pitch: 300
			},
			{
				max: 95,
				min: 85,
				pitch: 200
			},
			{
				max: 85,
				min: 75,
				pitch: 100
			},
			{
				max: 75,
				min: 65,
				pitch: -100
			},
			{
				max: 65,
				min: 55,
				pitch: -200
			},
			{
				max: 55,
				min: 51,
				pitch: -300
			},
			{
				max: 51,
				min: 0,
				pitch: -400
			}
		],
		respirationDataControls: [
			{
				max: 1,
				min: 0,
				pitch: 0,
				graphData: {
					coordinates: [0, 0],
					smoothStep: 0
				}
			},
			{
				max: 200,
				min: 195,
				pitch: 0,
				graphData: {
					curveResetTimer: 25,
					smoothStep: 1.65
				}
			},
			{
				max: 195,
				min: 185,
				graphData: {
					curveResetTimer: 33,
					smoothStep: 1.53
				}
			},
			{
				max: 185,
				min: 175,
				graphData: {
					curveResetTimer: 42,
					smoothStep: 1.42
				}
			},
			{
				max: 175,
				min: 165,
				graphData: {
					curveResetTimer: 51,
					smoothStep: 1.3
				}
			},
			{
				max: 165,
				min: 155,
				graphData: {
					curveResetTimer: 63,
					smoothStep: 1.18
				}
			},
			{
				max: 155,
				min: 145,
				graphData: {
					curveResetTimer: 75,
					smoothStep: 1.07
				}
			},
			{
				max: 145,
				min: 135,
				graphData: {
					curveResetTimer: 89,
					smoothStep: 0.95
				}
			},
			{
				max: 135,
				min: 125,
				graphData: {
					curveResetTimer: 106,
					smoothStep: 0.84
				}
			},
			{
				max: 125,
				min: 115,
				graphData: {
					curveResetTimer: 125,
					smoothStep: 0.74
				}
			},
			{
				max: 115,
				min: 105,
				graphData: {
					curveResetTimer: 148,
					smoothStep: 0.66
				}
			},
			{
				max: 105,
				min: 95,
				graphData: {
					curveResetTimer: 175,
					smoothStep: 0.58
				}
			},
			{
				max: 95,
				min: 85,
				graphData: {
					curveResetTimer: 208,
					smoothStep: 0.51
				}
			},
			{
				max: 85,
				min: 75,
				graphData: {
					curveResetTimer: 250,
					smoothStep: 0.46
				}
			},
			{
				max: 75,
				min: 65,
				graphData: {
					curveResetTimer: 304,
					smoothStep: 0.39
				}
			},
			{
				max: 65,
				min: 55,
				graphData: {
					curveResetTimer: 375,
					smoothStep: .32
				}
			},
			{
				max: 55,
				min: 45,
				graphData: {
					curveResetTimer: 475,
					smoothStep: .25
				}
			},
			{
				max: 45,
				min: 35,
				graphData: {
					curveResetTimer: 625,
					smoothStep: .2
				}
			},
			{
				max: 35,
				min: 25,
				graphData: {
					curveResetTimer: 875,
					smoothStep: .15
				}
			},
			{
				max: 25,
				min: 15,
				graphData: {
					curveResetTimer: 1375,
					smoothStep: .1
				}
			},
			{
				max: 15,
				min: 1,
				graphData: {
					curveResetTimer: 2875,
					smoothStep: .05
				}
			},
		],

		etc02DataInMonitorUIData: {
			showGrid: false,
			//defaultCoordinates: [0, 0, 0, 0, 0, 0, 0, 5, 10, 14, 16, 17, 16, 14, 10, 7, 5, 4, 3, 2, 1, 0, -2, -4, -6, 10, 56, 20, 10, 0, 0, 0, -5, 0, 0, 0, 5, 6, 7, 8, 9, 9, 9, 8, 7, 6, 5, 4],
			
				defaultCoordinates: [
					0.05 ,1.27 ,2.85 ,// 1.5x increments
					11.16,16.91,20.41,25.32,30.61,35.23,40.83, //5.xx increments
					45.27,45.39,45.41,45.54,45.61,45.73,45.82,45.96,46.07,46.19, //0.07 - 0.1x increments
					46.21,46.32,46.46,46.58,46.69,46.71,46.80,46.93,47.04,47.16, //0.07 - 0.1x increments
					47.21,47.32,47.46,47.59,47.62,47.73,47.81,47.95,48.07,48.12, //0.07 - 0.1x increments
					48.21,48.36,48.44,48.59,48.61,48.79,48.85,48.91,49.09,49.13, //0.07 - 0.1x increments
					49.27,49.32,49.49,49.51,49.69,49.75,49.82,49.98,50.03,50.16, //0.07 - 0.1x increments
					50.23,50.39,50.47,50.53,  //0.07 - 0.1x increments 
					50.69,50.81,50.97,51.21,51.36,51.48,51.55,51.62,51.71,51.29,
					// <<<<< END OF ASCENT
					//50.41,50.33,50.28,50.11,50.06,49.51,49.03,   //0.05 - 0.1x decrements
					48.08,47.09,45.07, //2.xx decrements
					40.09,35.08,30.01,25.05,20.01,15.03,10.03,5.05 , //4.xx - 5.xx decrements
					4.06 ,3.07 ,2.06 ,1.07 , // 1.0x decrements
					0.99 ,0.87 ,0.76 ,0.65 ,0.54 ,0.42 ,0.31 ,0.23 ,   //0.1x decrements
					0.12 ,0.08 ,0.07 ,0.03 ,0.05 ,0.09 ,0.03 ,0.05 ,0.02 ,0.01 //0.01 - 0.08 assorted increments and decrements 
					//<<<<<< END OF DESCENT
				],
			defaultCurveResetTimer: 500,
			timeInterval: 20,
			lineColor: 'yellow',
			centerHeight:true,
		},
		etc02DataInMonitorUIDataControls: [
			{
				max: 1,
				min: 0,
				graphData: {
					coordinates: [0, 0],
				}
			},
			{
				max: 36,
				min: 30,
				graphData: {
					curveResetTimer: 100
				}
			},
			{
				max: 30,
				min: 24,
				graphData: {
					curveResetTimer: 300
				}
			},
			{
				max: 24,
				min: 18,
				graphData: {
					curveResetTimer: 500
				}
			},
			{
				max: 18,
				min: 12,
				graphData: {
					curveResetTimer: 800
				}
			},
			{
				max: 12,
				min: 6,
				graphData: {
					curveResetTimer: 1200
				}
			},
			{
				max: 6,
				min: 1,
				graphData: {
					curveResetTimer: 1500
				}
			},
		],

		etc02DataInVitalsUIData: {
			showGrid: false,
			//defaultCoordinates: [0, 0, 0, 0, 0, 0, 0, 5, 10, 14, 16, 17, 16, 14, 10, 7, 5, 4, 3, 2, 1, 0, -2, -4, -6, 10, 56, 20, 10, 0, 0, 0, -5, 0, 0, 0, 5, 6, 7, 8, 9, 9, 9, 8, 7, 6, 5, 4],
			
				defaultCoordinates: [
					0.05 ,1.27 ,2.85 ,// 1.5x increments
					11.16,16.91,20.41,25.32,30.61,35.23,40.83, //5.xx increments
					45.27,45.39,45.41,45.54,45.61,45.73,45.82,45.96,46.07,46.19, //0.07 - 0.1x increments
					46.21,46.32,46.46,46.58,46.69,46.71,46.80,46.93,47.04,47.16, //0.07 - 0.1x increments
					47.21,47.32,47.46,47.59,47.62,47.73,47.81,47.95,48.07,48.12, //0.07 - 0.1x increments
					48.21,48.36,48.44,48.59,48.61,48.79,48.85,48.91,49.09,49.13, //0.07 - 0.1x increments
					49.27,49.32,49.49,49.51,49.69,49.75,49.82,49.98,50.03,50.16, //0.07 - 0.1x increments
					50.23,50.39,50.47,50.53,  //0.07 - 0.1x increments 
					50.69,50.81,50.97,51.21,51.36,51.48,51.55,51.62,51.71,51.29,
					// <<<<< END OF ASCENT
					//50.41,50.33,50.28,50.11,50.06,49.51,49.03,   //0.05 - 0.1x decrements
					48.08,47.09,45.07, //2.xx decrements
					40.09,35.08,30.01,25.05,20.01,15.03,10.03,5.05 , //4.xx - 5.xx decrements
					4.06 ,3.07 ,2.06 ,1.07 , // 1.0x decrements
					0.99 ,0.87 ,0.76 ,0.65 ,0.54 ,0.42 ,0.31 ,0.23 ,   //0.1x decrements
					0.12 ,0.08 ,0.07 ,0.03 ,0.05 ,0.09 ,0.03 ,0.05 ,0.02 ,0.01 //0.01 - 0.08 assorted increments and decrements 
					//<<<<<< END OF DESCENT
				],
			defaultCurveResetTimer: 500,
			timeInterval: 20,
			lineColor: 'yellow',
			centerHeight: true
		},
		etc02DataInVitalsUIDataControls: [
			{
				max: 1,
				min: 0,
				graphData: {
					coordinates: [0, 0],
				}
			},
			{
				max: 36,
				min: 30,
				graphData: {
					curveResetTimer: 100
				}
			},
			{
				max: 30,
				min: 24,
				graphData: {
					curveResetTimer: 300
				}
			},
			{
				max: 24,
				min: 18,
				graphData: {
					curveResetTimer: 500
				}
			},
			{
				max: 18,
				min: 12,
				graphData: {
					curveResetTimer: 800
				}
			},
			{
				max: 12,
				min: 6,
				graphData: {
					curveResetTimer: 1200
				}
			},
			{
				max: 6,
				min: 1,
				graphData: {
					curveResetTimer: 1500
				}
			},
		],
	},
	smeDebug: {
		variables: {
			apneaInductionTime: 'sme-apnea-indication-time',
			apneaApneaTime: 'sme-apnea-apnea-time',
			vitalsBpNumerator: 'sme-vitals-bp-numerator',
			vitalsBpDenominator: 'sme-vitals-bp-denomiator',
			vitalsMinBpNumerator: 'sme-vitals-min-bp-numerator',
			vitalsMinBpDenominator: 'sme-vitals-min-bp-denomiator',
			vitalsMaxBpNumerator: 'sme-vitals-max-bp-numerator',
			vitalsMaxBpDenominator: 'sme-vitals-max-bp-denomiator',
			vitalsBpMultiplier: 'sme-vitals-bp-multiplier',
			vitalsHr: 'sme-vitals-hr',
			vitalsMaxHr: 'sme-vitals-hr-max',
			vitalsHrMultiplier: 'sme-vitals-hr-multiplier',
			vitalsEtc02: 'sme-vitals-etc02',
			vitalsRR: 'sme-vitals-rr',
			vitalsSa02: 'sme-vitals-sa02',
			vitalsSa02Multiplier: 'sme-vitals-sa02-multiplier'
		},
		globalEvents: {
			smeDebugUpdate: 'sme-debug-update'
		}
	}
};